import axios from 'axios';

const baseURL = process.env.QUICK_LINKS_API_URL;
const blobsBaseUrl = `${baseURL}/v1/blobs`;

const blobs = {
    // POST /links Create a new link
    async create(fileData, organisation) {
        const config = {
            headers: { 'Content-Type': 'multipart/form-data' }
        };
        return axios.post(`${blobsBaseUrl}?organisation=${organisation}`, fileData, config);
    },
    async getLinks(id, organisation) {
        return axios.get(`${blobsBaseUrl}/${id}?organisation=${organisation}`, { responseType: 'arraybuffer' }).then((result) => {
            return result;
        });
    }
};

export default blobs;



// WEBPACK FOOTER //
// ./src/api/blobs.js